import { render } from "./manage-programs.vue?vue&type=template&id=d85decba&lang=pug"
import script from "./manage-programs.vue?vue&type=script&lang=js"
export * from "./manage-programs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__